import { takeLatest, call, all, put } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import api from '~/services/apiBearer';

import {
  ListPropertiesResponse,
  GetDataSecondBilletResponse,
  GetReservationFundsResponse,
} from './actions';

import { signOut } from '../auth/actions';

export function* listProperties({ payload }) {
  try {
    const { token } = payload;

    if (!token) return;

    api.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(api.get, 'api/v1/WSListaImovel');

    const { sucesso, mensagem, conteudo, totalPaginas } = response.data;

    if (mensagem.includes('Token inválido.')) {
      return yield put(signOut());
    }

    if (!sucesso) {
      toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
      console.log(`Erro: ${mensagem}`);
    }

    yield put(
      ListPropertiesResponse({
        properties: conteudo.sort((x, y) => {
          const xVal = x.situacao === 'Ativo';
          const yVal = y.situacao === 'Ativo';

          // eslint-disable-next-line no-nested-ternary
          return xVal === yVal ? 0 : xVal ? -1 : 1;
        }),
        totalPages: totalPaginas,
      })
    );
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export function* getDataSecondBillet({ payload }) {
  try {
    const { token, page, totalPages, contractId } = payload;

    if (!token) return;

    api.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(api.get, 'api/v1/WSBoleto', {
      params: {
        contrato: contractId,
        pagina: page,
        tamanhoPagina: totalPages,
      },
    });

    const { sucesso, mensagem, conteudo, totalPaginas } = response.data;

    if (mensagem.includes('Token inválido.')) {
      return yield put(signOut());
    }

    if (!sucesso) {
      toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
      console.log(`Erro: ${mensagem}`);
    }

    yield put(
      GetDataSecondBilletResponse({ data: conteudo, totalPages: totalPaginas })
    );
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export function* getReservationsFunds({ payload }) {
  try {
    const { token, contractId, pages, totalPages } = payload;

    if (!token) return;

    api.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(api.get, 'api/v1/WSFundoReserva', {
      params: {
        contrato: contractId,
        pagina: pages,
        tamanhoPagina: totalPages,
      },
    });

    const { sucesso, mensagem, conteudo, totalPaginas } = response.data;

    if (mensagem.includes('Token inválido.')) {
      return yield put(signOut());
    }

    if (!sucesso) {
      console.error(mensagem);
      toast.error(`Erro: Ocorreu um erro interno, tente novamente mais tarde.`);
    }

    yield put(
      GetReservationFundsResponse({ data: conteudo, totalPages: totalPaginas })
    );
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export default all([
  takeLatest('@properties/LIST_PROPERTIES_REQUEST', listProperties),
  takeLatest('@properties/GET_SECOND_BILLET_REQUEST', getDataSecondBillet),
  takeLatest('@properties/GET_RESERVATION_FUNDS_REQUEST', getReservationsFunds),
]);
